module.exports = __webpack_public_path__ + "img/u104.fc0ffd84.jpg";